module.exports = __webpack_public_path__ + "static/favicon-079d807382b48e632fe2bd438f10cd47.ico";